import { setScrollPageStorage } from '@/redux/slices/app';
import { dispatch } from '@/redux/store';
import {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';

export default function useScrollList({ page, restoreList }) {
  const { scrollPageStorage } = useSelector(state => state.app);
  const [cachedInfo, setCachedInfo] = useState(); 

  useEffect(() => {
    _updateCachedInfo();
  }, []);

  const _updateCachedInfo = () => {
    if (!scrollPageStorage || !page) {
      return;
    }

    setCachedInfo(scrollPageStorage[page]);
  }

  useEffect(() => {
    _restoreList();
  }, [cachedInfo]);

  const _restoreList = () => {
    if (!cachedInfo) return;

    const listInfo = cachedInfo['listInfo'];
    if (restoreList && listInfo) {
      restoreList({
        list: listInfo.list ?? [],
        pageNum: listInfo.pageNum,
        pageSize: listInfo.pageSize,
      });
    }
  }

  const restoreScrollPosition = () => {
    if (cachedInfo) {
      // 还原纵向进度条
      cachedInfo.scrollY
    }
  }

  const clearScrollList = () => {
    dispatch(setScrollPageStorage({
      [page]: null
    }));
  }

  const cacheScrollList = (listInfo) => {
    dispatch(setScrollPageStorage({
      [page]: {
        listInfo: listInfo,
        scrollY: _getScrollY(),
      }
    }));
  }

  const _getScrollY = () => {
    return null;
  }

  return {
    restoreScrollPosition,
    cacheScrollList,
    clearScrollList,
  };
}
